import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';
import { TranslocoPercentPipe } from '@jsverse/transloco-locale';
import { BillingPeriod } from '@dss-libs/portal/type/portal-types';

@Component({
  selector: 'dss-libs-ui-payment-filter',
  imports: [TranslocoDirective, TranslocoPercentPipe],
  templateUrl: './payment-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentFilterComponent {
  readonly selectedPlanType = model<BillingPeriod>();
  readonly yearlyDiscount = input<number>(0);

  togglePlanType() {
    this.selectedPlanType.set(
      this.selectedPlanType() === BillingPeriod.Month ? BillingPeriod.Year : BillingPeriod.Month
    );
  }

  protected readonly BillingPeriod = BillingPeriod;
}
